var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.65 116.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#_1);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#_1-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#_1-3);}.cls-8{mix-blend-mode:hard-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1",
    x1: 54.32,
    y1: 90.66,
    x2: 54.32,
    y2: 116.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2ffb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.32,
    y1: 67.29,
    x2: 54.32,
    y2: 4.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89c628",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 54.32,
    y1: 57.52,
    x2: 54.32,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1-2",
    x1: 54.32,
    y1: 19.98,
    x2: 54.32,
    y2: 74.9,
    xlinkHref: "#_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 54.32,
    y1: 79.9,
    x2: 54.32,
    y2: 11.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1-3",
    x1: 54.32,
    y1: 42.09,
    x2: 54.32,
    y2: 100.66,
    xlinkHref: "#_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.58 110.04 80.58 116.8 54.32 97.42 28.06 116.8 28.06 110.04 54.32 90.66 80.58 110.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,9.37l3.93,4.92L94.31,59.37h0l3.93,4.92H84.51l-3.93-4.92L54.32,26.55l-3.93,4.92L28.06,59.37l-3.93,4.92H10.39l3.93-4.92h0L50.39,14.29l3.93-4.92m0-4.81L52,7.49l-3.93,4.92-35.16,44h0L12,57.49,8.05,62.41,4.16,67.29H25.58l.9-1.13,3.93-4.92,22.33-27.9,1.59-2L78.24,61.24l3.93,4.92.9,1.13h21.42l-3.89-4.88-3.93-4.92-.9-1.12h0l-35.16-44L56.67,7.49,54.32,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.32,1.6l3.93,4.92L94.31,51.6h0l3.93,4.92H84.51L80.58,51.6,54.32,18.78,50.39,23.7,28.06,51.6l-3.93,4.92H10.39l3.93-4.92h0L50.39,6.52,54.32,1.6m0-1.6-.78,1L49.61,5.9,13.85,50.6h0l-.31.38L9.61,55.9l-1.3,1.62h16.3l.3-.37,3.93-4.92,22.33-27.9,3.15-3.95L79.8,52.23l3.93,4.92.3.37h16.3L99,55.9,95.1,51l-.3-.38h0L59,5.9,55.1,1l-.78-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.25 74.9 84.51 74.9 80.58 69.98 54.32 37.16 50.39 42.08 28.06 69.98 24.13 74.9 10.39 74.9 14.32 69.98 14.33 69.98 50.39 24.9 54.32 19.98 58.25 24.9 94.31 69.98 94.32 69.98 98.25 74.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.32,20l3.93,4.92L94.31,70h0l3.93,4.92H84.51L80.58,70,54.32,37.16l-3.93,4.92L28.06,70,24.13,74.9H10.39L14.32,70h0L50.39,24.9,54.32,20m0-8-3.9,4.89-3.93,4.92L11.93,65h0l-1.51,1.88L6.49,71.78,0,79.9H26.54L28,78,32,73.1,54.3,45.2l0,0L76.68,73.1,80.61,78l1.5,1.88h26.54l-6.49-8.12-3.93-4.92L96.73,65h0L62.16,21.77l-3.93-4.91L54.32,12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "80.58 74.91 80.58 100.66 54.32 81.28 28.06 100.66 28.06 74.91 54.32 42.09 80.58 74.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.58 110.04 80.58 116.8 54.32 97.42 28.06 116.8 28.06 110.04 54.32 90.66 80.58 110.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,9.37l3.93,4.92L94.31,59.37h0l3.93,4.92H84.51l-3.93-4.92L54.32,26.55l-3.93,4.92L28.06,59.37l-3.93,4.92H10.39l3.93-4.92h0L50.39,14.29l3.93-4.92m0-4.81L52,7.49l-3.93,4.92-35.16,44h0L12,57.49,8.05,62.41,4.16,67.29H25.58l.9-1.13,3.93-4.92,22.33-27.9,1.59-2L78.24,61.24l3.93,4.92.9,1.13h21.42l-3.89-4.88-3.93-4.92-.9-1.12h0l-35.16-44L56.67,7.49,54.32,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.32,1.6l3.93,4.92L94.31,51.6h0l3.93,4.92H84.51L80.58,51.6,54.32,18.78,50.39,23.7,28.06,51.6l-3.93,4.92H10.39l3.93-4.92h0L50.39,6.52,54.32,1.6m0-1.6-.78,1L49.61,5.9,13.85,50.6h0l-.31.38L9.61,55.9l-1.3,1.62h16.3l.3-.37,3.93-4.92,22.33-27.9,3.15-3.95L79.8,52.23l3.93,4.92.3.37h16.3L99,55.9,95.1,51l-.3-.38h0L59,5.9,55.1,1l-.78-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.25 74.9 84.51 74.9 80.58 69.98 54.32 37.16 50.39 42.08 28.06 69.98 24.13 74.9 10.39 74.9 14.32 69.98 14.33 69.98 50.39 24.9 54.32 19.98 58.25 24.9 94.31 69.98 94.32 69.98 98.25 74.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.32,20l3.93,4.92L94.31,70h0l3.93,4.92H84.51L80.58,70,54.32,37.16l-3.93,4.92L28.06,70,24.13,74.9H10.39L14.32,70h0L50.39,24.9,54.32,20m0-8-3.9,4.89-3.93,4.92L11.93,65h0l-1.51,1.88L6.49,71.78,0,79.9H26.54L28,78,32,73.1,54.3,45.2l0,0L76.68,73.1,80.61,78l1.5,1.88h26.54l-6.49-8.12-3.93-4.92L96.73,65h0L62.16,21.77l-3.93-4.91L54.32,12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "80.58 74.91 80.58 100.66 54.32 81.28 28.06 100.66 28.06 74.91 54.32 42.09 80.58 74.91"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/Green.aab776adb0af2aa8cce701b0ae7e7bce.svg";
export { ForwardRef as ReactComponent };